export default async function vue() {
  const { default: Vue } = await import(
    /* webpackChunkName: "components/vue" */
    'vue/dist/vue.esm.js'
  )
  return Vue;
}
